export function parseCeSharedDomain() {
    var firstDotIndex = window.location.hostname.indexOf('.');
    return window.location.hostname.substring(firstDotIndex === -1 ? 0 : firstDotIndex + 1);
}